import { PropsWithChildren, ReactNode } from 'react'
import { cn } from '@scalis/utils'
import { Avatar } from '../avatar'

export interface UserInfoProps {
  src?: string
  icon?: ReactNode
  email?: string | undefined
  fullName: string
  disabled?: boolean
  onClick?: () => void
  color?: string
}

export const UserInfo = ({
  src,
  icon,
  fullName,
  email,
  onClick,
  disabled,
  children,
  color,
}: PropsWithChildren<UserInfoProps>) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={cn('flex items-center gap-2', onClick && 'cursor-pointer', disabled && 'cursor-default opacity-50')}
    >
      {icon ?? (
        <Avatar
          src={src}
          fullName={fullName}
        />
      )}

      <div className='flex flex-col'>
        <p
          data-testid='user-info-full-name'
          className='body-small-basic text-neutral-primary'
        >
          {fullName}
        </p>
        {email && <p className='caption-basic text-neutral-secondary'>{email}</p>}
      </div>
      <div className='ml-auto flex items-center gap-2'>
        {color && (
          <div
            className='square h-4 w-4 rounded-xs'
            style={{ backgroundColor: color }}
          />
        )}
        {children && <div className=''>{children}</div>}
      </div>
    </div>
  )
}
